// extracted by mini-css-extract-plugin
module.exports = {"main":"ProfessionalReseller_main___NHDi","subTitle":"ProfessionalReseller_subTitle__wjd4x","button":"ProfessionalReseller_button__RaKxn"};